import { FrontendUser } from '@project/types/shared';
import React, { memo, PropsWithChildren, useContext } from 'react';

interface ConfigData {
  locales: string[];
  selectedLocale: string;
  appBranding: string;
  isMobileApp: boolean;
  websiteUrl: string;
  facebook: { pageurl: string };
  build: { build_date: string; git_hash: string };
  appStoreUrls: { fr: { iosUrl: string; androidUrl: string }; otherwise: { iosUrl: string; androidUrl: string } };
  authenticated: boolean;
  loggedUser: FrontendUser;
}

export class ConfigClass implements ConfigData {
  public appBranding: string;
  public appStoreUrls: { fr: { iosUrl: string; androidUrl: string }; otherwise: { iosUrl: string; androidUrl: string } };
  public build: { build_date: string; git_hash: string };
  public facebook: { pageurl: string };
  public isMobileApp: boolean;
  public locales: string[];
  public selectedLocale: string;
  public websiteUrl: string;
  public authenticated: boolean;
  public loggedUser: FrontendUser;

  constructor(data: ConfigData) {
    this.appBranding = data.appBranding;
    this.appStoreUrls = data.appStoreUrls;
    this.build = data.build;
    this.facebook = data.facebook;
    this.isMobileApp = data.isMobileApp;
    this.locales = data.locales;
    this.selectedLocale = data.selectedLocale;
    this.websiteUrl = data.websiteUrl;
    this.authenticated = data.authenticated;
    this.loggedUser = data.loggedUser;
  }

  public localeAppStoreUrl(storeName: 'app-store' | 'play-store' | string): string {
    const urls: { iosUrl: string; androidUrl: string } = this.appStoreUrls[this.selectedLocale] || this.appStoreUrls.otherwise;
    switch (storeName) {
      case 'app-store':
        return urls.iosUrl;
      case 'play-store':
        return urls.androidUrl;
    }
  }
}

class ConfigFromWindow implements ConfigData {
  public appBranding;
  public appStoreUrls;
  public build;
  public facebook;
  public isMobileApp;
  public locales;
  public selectedLocale;
  public websiteUrl;
  public authenticated;
  public loggedUser;

  constructor() {
    this.appBranding = (window as any).appBranding;
    this.appStoreUrls = (window as any).appStoreUrls;
    this.build = (window as any).viewConfig.build;
    this.facebook = (window as any).viewConfig.facebook;
    this.isMobileApp = (window as any).isMobileApp;
    this.locales = (window as any).locales;
    this.selectedLocale = (window as any).selectedLocale;
    this.websiteUrl = (window as any).websiteUrl;
    this.authenticated = (window as any).aauthenticated;
    this.loggedUser = (window as any).loggedUser;
  }
}

export const ConfigContext = React.createContext<ConfigClass>(null);

export const Config = memo(function Config({ children }: PropsWithChildren<object>) {
  return <ConfigContext.Provider value={new ConfigClass(new ConfigFromWindow())}>{children}</ConfigContext.Provider>;
});

export const useConfig = () => useContext(ConfigContext);
